import React from 'react';
import { Box, Pagination } from '@mui/material';

const Paging = ({ currentPage, totalPages, onPageChange }) => {
  console.log('Paging currentPage:', currentPage);
  console.log('Paging totalPages:', totalPages);

  const handlePageChange = (event, page) => {
    console.log('Page changed to:', page);
    onPageChange(page);
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" mt={2} p={1} borderRadius={4}>
      <Pagination
        count={totalPages}
        page={currentPage}
        color="primary"
        onChange={handlePageChange}
        showFirstButton
        showLastButton
      />
    </Box>
  );
};


export default Paging;
